import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import api from '../api';
import TopNav from '../components/TopNav';
import BottomNav from '../components/BottomNav';
import ExpressCheckoutButton from '../components/ExpressCheckoutButton';

const Cart = ({ deviceId }) => {
  const navigate = useNavigate();
  const [cart, setCart] = useState({ items: [], total: 0 });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadCart();
  }, [deviceId]);

  const loadCart = async () => {
    try {
      setLoading(true);
      const data = await api.getCart(deviceId);
      const total = data.items?.reduce((sum, item) => sum + (item.price * item.quantity), 0) || 0;
      setCart({ ...data, total });
    } catch (error) {
      console.error('Error loading cart:', error);
    } finally {
      setLoading(false);
    }
  };

  const updateQuantity = async (variantId, newQuantity) => {
    if (newQuantity < 1) return;
    
    try {
      await api.updateCartQuantity(deviceId, variantId, newQuantity);
      await loadCart();
    } catch (error) {
      console.error('Error updating quantity:', error);
    }
  };

  const removeItem = async (variantId) => {
    try {
      await api.removeFromCart(deviceId, variantId);
      await loadCart();
    } catch (error) {
      console.error('Error removing item:', error);
    }
  };

  if (loading) {
    return (
      <div style={{ minHeight: '100vh', background: '#FEFEE3', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <TopNav deviceId={deviceId} />
        <p style={{ color: '#4C956C' }}>LOADING CART...</p>
        <BottomNav currentPath="/cart" />
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', background: '#FEFEE3', paddingBottom: '180px' }}>
      <TopNav deviceId={deviceId} currentPath="/cart" />
      
      <div style={{ maxWidth: '800px', margin: '0 auto', padding: '20px' }}>
        <h1 style={{ fontSize: '24px', color: '#2C6E49', marginBottom: '30px', textAlign: 'center' }}>[ YOUR CART ]</h1>
        
        {cart.items && cart.items.length === 0 ? (
          <div className="retro-card" style={{ background: '#FFF', padding: '60px 20px', textAlign: 'center' }}>
            <p style={{ fontSize: '18px', color: '#4C956C', marginBottom: '30px' }}>YOUR CART IS EMPTY</p>
            <Link to="/" className="retro-btn" style={{ display: 'inline-block', background: '#2C6E49', color: '#FEFEE3', padding: '15px 30px', textDecoration: 'none' }}>
              CONTINUE SHOPPING >>>
            </Link>
          </div>
        ) : (
          <>
            <div style={{ marginBottom: '20px' }}>
              {cart.items.map((item) => (
                <div key={item.variant_id} className="retro-card" style={{ background: '#FFF', padding: '20px', marginBottom: '15px' }}>
                  <div style={{ display: 'flex', gap: '20px' }}>
                    <div style={{ width: '80px', height: '80px', border: '2px solid #000', background: '#F7F6D8', flexShrink: 0 }}>
                      {item.image_url && <img src={item.image_url} alt={item.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />}
                    </div>
                    
                    <div style={{ flex: 1 }}>
                      <h3 style={{ fontSize: '14px', color: '#2C6E49', marginBottom: '5px', fontWeight: 'bold' }}>{item.name}</h3>
                      <p style={{ fontSize: '11px', color: '#4C956C', marginBottom: '5px' }}>{item.color} / {item.size}</p>
                      <p style={{ fontSize: '16px', color: '#2C2C2C', fontWeight: 'bold' }}>${item.price.toFixed(2)}</p>
                    </div>
                    
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', alignItems: 'flex-end' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <button
                          onClick={() => updateQuantity(item.variant_id, item.quantity - 1)}
                          className="retro-btn"
                          style={{ background: '#FFF', color: '#2C2C2C', padding: '5px 12px', fontSize: '14px' }}
                        >
                          -
                        </button>
                        <span style={{ fontSize: '16px', fontWeight: 'bold', minWidth: '30px', textAlign: 'center' }}>{item.quantity}</span>
                        <button
                          onClick={() => updateQuantity(item.variant_id, item.quantity + 1)}
                          className="retro-btn"
                          style={{ background: '#FFF', color: '#2C2C2C', padding: '5px 12px', fontSize: '14px' }}
                        >
                          +
                        </button>
                      </div>
                      
                      <button
                        onClick={() => removeItem(item.variant_id)}
                        className="retro-btn"
                        style={{ background: '#FF5A5F', color: '#FFF', padding: '8px 15px', fontSize: '11px' }}
                      >
                        REMOVE
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            
            <div style={{ position: 'fixed', bottom: '70px', left: 0, right: 0, background: '#000', padding: '20px', borderTop: '3px solid #000', zIndex: 999 }}>
              <div style={{ maxWidth: '800px', margin: '0 auto' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
                  <div>
                    <p style={{ color: '#FFC857', fontSize: '12px', marginBottom: '5px' }}>TOTAL</p>
                    <p style={{ color: '#FEFEE3', fontSize: '28px', fontWeight: 'bold' }}>${cart.total.toFixed(2)}</p>
                  </div>
                  <button
                    onClick={() => navigate('/checkout')}
                    className="retro-btn"
                    style={{ background: '#4AE54A', color: '#000', padding: '20px 40px', fontSize: '14px' }}
                  >
                    CHECKOUT >>>
                  </button>
                </div>
                <ExpressCheckoutButton
                  mode="cart"
                  items={cart.items.map((it) => ({
                    product_id: it.product_id,
                    variant_id: it.variant_id,
                    name: it.name,
                    color: it.color,
                    size: it.size,
                    quantity: it.quantity,
                    price: it.price,
                    image_url: it.image_url,
                  }))}
                  deviceId={deviceId}
                />
              </div>
            </div>
          </>
        )}
      </div>
      
      <BottomNav currentPath="/cart" />
    </div>
  );
};

export default Cart;
